import { LogLevel } from './Logger';
export class ConsoleLogger {
    logLevel;
    constructor(logLevel = LogLevel.critical) {
        this.logLevel = logLevel;
    }
    debug(log, ...rest) {
        if (this.logLevel >= LogLevel.debug) {
            console.log(log, ...rest);
        }
        return Promise.resolve();
    }
    information(log, ...rest) {
        if (this.logLevel >= LogLevel.information) {
            console.info(log, ...rest);
        }
        return Promise.resolve();
    }
    warning(log, ...rest) {
        if (this.logLevel >= LogLevel.warning) {
            console.warn(log, ...rest);
        }
        return Promise.resolve();
    }
    error(log, ...rest) {
        if (this.logLevel >= LogLevel.error) {
            console.error(log, ...rest);
        }
        return Promise.resolve();
    }
    critical(log, ...rest) {
        if (this.logLevel >= LogLevel.critical) {
            console.error(log, ...rest);
        }
        return Promise.resolve();
    }
}
